/**
 * AI Recruit - Idle Timeout Configuration
 * Centralized configuration for idle timeout settings
 */

export const IDLE_TIMEOUT_CONFIG = {
  // Timeout settings (in minutes)
  TIMEOUT_MINUTES: 30,       // Total idle time before logout
  WARNING_MINUTES: 2,        // Warning time before logout
  
  // Events that reset the idle timer
  RESET_EVENTS: [
    'mousedown',
    'mousemove', 
    'keypress',
    'keydown',
    'scroll',
    'touchstart',
    'click',
    'focus',
    'blur'
  ],
  
  // Additional settings
  ENABLE_CONSOLE_LOGS: process.env.NODE_ENV === 'development',
  SHOW_WARNING_DIALOG: true,
  AUTO_LOGOUT_ON_TIMEOUT: true
} as const

export type IdleTimeoutConfig = typeof IDLE_TIMEOUT_CONFIG
